import { render } from "./CardView.vue?vue&type=template&id=042103d2&scoped=true"
import script from "./CardView.vue?vue&type=script&lang=js"
export * from "./CardView.vue?vue&type=script&lang=js"

import "./CardView.vue?vue&type=style&index=0&id=042103d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042103d2"]])

export default __exports__